
import React from 'react';
import { cn } from '@/lib/utils';

interface WaveProps {
  className?: string;
  color?: string;
  height?: number;
}

export const Wave = ({ 
  className, 
  color = '#c8a87d', // Default to brand gold color
  height = 60 
}: WaveProps) => {
  return (
    <div className={cn("w-full overflow-hidden", className)}>
      <svg
        preserveAspectRatio="none"
        width="100%"
        height={height}
        viewBox="0 0 1440 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 27L48 24.3C96 21.7 192 16.3 288 13.5C384 10.7 480 10.3 576 16.2C672 21.7 768 32.3 864 37.8C960 43.3 1056 43.7 1152 40.5C1248 37.3 1344 30.7 1392 27.3L1440 24V54H1392C1344 54 1248 54 1152 54C1056 54 960 54 864 54C768 54 672 54 576 54C480 54 384 54 288 54C192 54 96 54 48 54H0V27Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default Wave;
